import { useQuery } from "@tanstack/react-query";
import { Megaphone } from "lucide-react";
import { apiList } from "../lib/api";
import { tickerSummaries } from "../lib/narratives";
import type { Announcement, IndicatorResult } from "../lib/types";

/** Scrolling marquee shown on every page: admin-managed announcements plus
 *  computed auto-summaries for the selected cycle. Pauses on hover; reduced-motion safe. */
export function Ticker({ cycle }: { cycle?: number }) {
  const ann = useQuery({ queryKey: ["announcements"], queryFn: () => apiList<Announcement>("/api/content/announcements/") });
  const ind = useQuery({
    queryKey: ["ticker-indicators", cycle],
    queryFn: () => apiList<IndicatorResult>(`/api/indicators/?cycle=${cycle}`),
    enabled: !!cycle,
  });
  const summaries = cycle ? tickerSummaries((ind.data ?? []).filter((r) => r.sex === "" && r.geo === null), cycle) : [];
  const items = [...(ann.data ?? []).map((a) => a.text), ...summaries];
  if (items.length === 0) return null;
  const loop = [...items, ...items]; // seamless wrap
  return (
    <div className="ticker" aria-label="Announcements">
      <span className="ticker-ico"><Megaphone size={14} /></span>
      <div className="ticker-mask">
        <div className="ticker-track">
          {loop.map((t, i) => <span className="ticker-item" key={i}>{t}<span className="ticker-dot">•</span></span>)}
        </div>
      </div>
    </div>
  );
}
